exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Colors-module__wrapper___Pyu4Y{position:absolute}@media screen and (min-width:525px){.Colors-module__wrapper___Pyu4Y{height:200px;width:200px}}.Colors-module__phase___2MZv_{position:absolute;border-radius:100%}.Colors-module__phase___2MZv_ h3{color:#fff;font-size:12px;text-transform:uppercase;position:relative;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}.Colors-module__phase___2MZv_.Colors-module__Begrijpen___1Qeti{top:-20px;left:250px;background:#3a95de}.Colors-module__phase___2MZv_.Colors-module__Ontdekken___1SJ3k{left:250px;top:175px;background:#72b280}.Colors-module__phase___2MZv_.Colors-module__Ontwerpen___iIBFT{top:250px;left:50%;background:#edca3e}.Colors-module__phase___2MZv_.Colors-module__Maken___rrYXZ{top:175px;left:-50px;background:#f48c50}.Colors-module__phase___2MZv_.Colors-module__Delen___Lyzau{top:0;left:-20px;background:#e43673}", ""]);

// exports
exports.locals = {
	"wrapper": "Colors-module__wrapper___Pyu4Y",
	"phase": "Colors-module__phase___2MZv_",
	"Begrijpen": "Colors-module__Begrijpen___1Qeti",
	"Ontdekken": "Colors-module__Ontdekken___1SJ3k",
	"Ontwerpen": "Colors-module__Ontwerpen___iIBFT",
	"Maken": "Colors-module__Maken___rrYXZ",
	"Delen": "Colors-module__Delen___Lyzau"
};